import { useStyleSheet } from '../../../../../../hooks/useStyleSheet';

export const useStyles = () => {
  const styles = useStyleSheet(
    (theme) => ({
      root: {
        '& > div:first-of-type': {
          margin: 0,
        },
        padding: theme.spacing.secondary,
      },
    }),
    [],
  );

  return styles;
};
